<template>
  <div>
    <app-table
        :items="items"
        :fields="fields"
        @row-clicked="showEditModal"
    />
    <app-edit-user-modal
        ref="AppEditUserModal"
        :clicked-user="clickedUser"
        @deleteUser="deleteUser"
        @updateUser="updateUser"
    />
  </div>
</template>
<script>
import AppTable from "@/common/AppTable.vue";
import {ApiService} from "@/api";
import AppEditUserModal from "@/components/AppEditUserModal.vue";
import {eventBus} from "@/eventBus";

export default {
  name: 'AppUserTable',
  components: {AppEditUserModal, AppTable},
  props: {
    isPredefined: {
      type: Boolean,
      default: false
    },
    externalItems: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      items: [],
      fields: [
        {
          key: 'id',
          label: 'user id',
        },
        {
          key: 'username',
          label: 'username'
        },
        {
          key: 'botKey',
          label: 'Бот-ключ'
        },
        {
          key: 'lastActivityDate',
          label: 'Последняя активность',
        },
        {
          key: 'startDate',
          label: 'Первый запуск',
        },
        {
          key: 'role',
          label: 'Роль',
          formatter: (value) => {
            if (!value) return 'Роль не выбрана'
            if (value === 'publisher') return 'Веб-мастер'
            return 'Рекламодатель'
          },
        },
        {
          key: 'lng',
          label: 'Язык',
          formatter: (value) => value ? value : 'Язык не выбран',
        },
      ],
      clickedUser: {},
    }
  },
  watch: {
    externalItems: {
      immediate: true,
      handler () {
        if (this.isPredefined) {
          this.items = this.externalItems
        }
      },
    },
  },
  mounted () {
    if (!this.isPredefined) {
      this.getUsers()
    }
    eventBus.$on("deleteUser", this.deleteUser);
    eventBus.$on("updateUser", this.updateUser);
  },
  beforeUnmount() {
    eventBus.$off("deleteUser", this.deleteUser);
    eventBus.$off("updateUser", this.updateUser);
  },
  methods: {
    getUsers() {
      return ApiService.getUsers()
          .then(res => {
            this.items = res
          })
          .catch(err => console.error(err))
    },
    showEditModal (clickedUser) {
      this.clickedUser = clickedUser
      this.$refs.AppEditUserModal.open()
    },
    deleteUser (id) {
      this.items = this.items.filter(user => user.id !== id)
    },
    updateUser (user) {
      const index = this.items.findIndex(itemUser => itemUser.id === user.id)
      if (index === -1) return
      this.items.splice(index, 1, user)
    },
  },
}
</script>
